export function formatRegionName(regionName: string) {
  const formatName = regionName.replace(/ /g, '_');
  return formatName;
}
